import React, { Component } from "react"
import { Link } from "gatsby"

import IosStore from "./IosStore"
import GooglePlay from "./GooglePlay"

export default class Footer extends Component {
  render() {
    return (
      <>
        <footer>
          <div className="container mx-auto">
            <div class="footer-widget__area">
              <div class="footer-widget">
                <div className="widget_one">
                  <h4 className="widget-title">Explore</h4>
                  <ul>
                    <li>
                      <Link to="/">about us</Link>
                    </li>
                    <li>
                      <Link to="/">get your card</Link>
                    </li>
                    <li>
                      <Link to="/">faq</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="footer-widget">
                <div className="widget_two">
                  <h4 className="widget-title">Contact</h4>
                  <ul>
                    <li>info@therandomcard.com</li>
                    <li>+91 9695608995</li>
                    <li>+91 8840168748</li>
                  </ul>
                </div>
              </div>
              <div class="footer-widget">
                <div className="widget_four">
                  <h4 className="widget-title">Download our app</h4>
                  <p>Available on</p>
                  <ul>
                    <li>
                      <IosStore />
                    </li>
                    <li>
                      <GooglePlay />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </footer>
        <div className="copyright">
          <div className="container mx-auto lg:px-0 px-8 pb-4">
            <div class=" flex flex-wrap">
              <div class="w-full">
                <p className="flex flex-wrap">
                  <span className="trc-by lg:mr-3 mr-0">
                    The Random Card by{" "}
                    <a
                      rel="dofollow"
                      target="_blank"
                      href="http://pixelnib.com/"
                    >
                      PixelNib
                    </a>{" "}
                  </span>
                  &nbsp;
                  <div className="uppercase">
                    |{" "}
                    <a className="lg:mx-3 mx-0" href="#">
                      Privacy policy
                    </a>{" "}
                    |&nbsp;
                    <a className="lg:ml-3 ml-0" href="#">
                      Terms & condition
                    </a>
                  </div>
                </p>
              </div>
              {/* <div class="lg:w-1/4 w-full">
                <p>
                  <span className="with_love">
                    Crafted with{" "}
                    <span role="img" aria-label="heart">
                      ❤️
                    </span>{" "}
                    by{" "}
                    <a
                      rel="dofollow"
                      target="_blank"
                      href="https://www.wayoutworks.in/"
                    >
                      way out works
                    </a>
                  </span>
                </p>
              </div> */}
            </div>
          </div>
        </div>
      </>
    )
  }
}
